import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination, Mousewheel, Keyboard } from 'swiper/modules';


new Swiper('.testimonial-slider.swiper', {
  modules: [Pagination, Mousewheel, Keyboard],
  direction: 'horizontal', 
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: '.testimonial-slider .swiper-pagination',
    clickable: true,
  },

  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
  },

  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
});